import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CrooperImg = _resolveComponent("CrooperImg");
  const _component_Homehead = _resolveComponent("Homehead");
  const _component_imagetransferHome = _resolveComponent("imagetransferHome");
  const _component_appWidget = _resolveComponent("appWidget");
  return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_component_CrooperImg, {
    key: $props.productName,
    ref: "cutImg",
    widthheight_ratio: $props.widthheight_ratio,
    isShowCropShape: $data.crop_showShape,
    crop_resizeSquare: $props.crop_shape_square_image,
    crop_horizontal: $props.crop_shape_horizontal_image,
    crop_vertical: $props.crop_shape_vertical_image,
    onOk: $options.onCropOk,
    onCancel: $options.onCropCancel
  }, null, 8, ["widthheight_ratio", "isShowCropShape", "crop_resizeSquare", "crop_horizontal", "crop_vertical", "onOk", "onCancel"])), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Homehead, {
    index: 1
  }), _createVNode(_component_imagetransferHome, {
    ref: "imagetransferHome",
    headImgUrl: $props.headImgUrl,
    product_introduce: $props.product_introduce,
    carousel_01: $props.carousel_01,
    carousel_02: $props.carousel_02,
    carousel_03: $props.carousel_03,
    carousel_04: $props.carousel_04,
    carousel_05: $props.carousel_05,
    carousel_06: $props.carousel_06,
    ex_original: $props.ex_original,
    ex_target: $props.ex_target,
    shopUrl: $props.shopUrl,
    product_type: $props.productName,
    onStartcrop: $options.startcrop
  }, null, 8, ["headImgUrl", "product_introduce", "carousel_01", "carousel_02", "carousel_03", "carousel_04", "carousel_05", "carousel_06", "ex_original", "ex_target", "shopUrl", "product_type", "onStartcrop"]), _cache[0] || (_cache[0] = _createElementVNode("div", {
    style: {
      "height": "40px"
    }
  }, null, -1))]), _createVNode(_component_appWidget, {
    appName: $props.productName,
    shopUrl: $props.shopUrl
  }, null, 8, ["appName", "shopUrl"])], 64);
}